import PropTypes from "prop-types";
import { SortByDropdown } from "@/react/components/Spaces/Header/SpaceHeaderActions/SortByDropdown";
import {
  isBasicPostsSpace,
  isImagesSpace,
  isMembersSpace,
} from "@/react/helpers/spaceHelpers";

export const SortOptions = ({ space }) => (
  <>
    {(isBasicPostsSpace(space) || isImagesSpace(space)) && (
      <div className="hidden md:flex">
        <SortByDropdown
          defaultSort={space?.default_sort || "latest"}
          showDescription={false}
          exclude={isImagesSpace(space) ? ["alphabetical"] : []}
        />
      </div>
    )}
    {isMembersSpace(space) && (
      <div className="hidden md:flex">
        <SortByDropdown
          defaultSort={space?.default_member_sort || "latest"}
          showDescription={false}
          include={["latest", "oldest", "alphabetical"]}
        />
      </div>
    )}
  </>
);

SortOptions.propTypes = {
  space: PropTypes.object.isRequired,
};
